import { motion } from 'framer-motion'
import styled from 'styled-components'

export const ConfirmCenterContainer = motion(styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 210;
	width: 90%;
	max-width: 550px;
`)

export const CloseBtn = styled.div`
	position: absolute;
	right: 21px;
	top: 17px;
    cursor: pointer;
`
export const ConfirmText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 13px;
	line-height: 122%;
	text-align: center;
	color: #484848;
	max-width: 376px;

    @media(max-width: 425px) {
     font-size: 11px;
    }
`

export const CheckboxContainer = styled.span`
	cursor: pointer;
	gap: 10px;
	align-items: center;
	display: flex;
	margin: 10px 0;
`

export const CheckboxCustom = styled.div<{ error?: boolean }>`
	min-width: 20px;
	height: 20px;
	background-color: #ffffff;
	border: 1px solid #000;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;

	&::after {
		content: '✔';
		color: #018d47;
		font-size: 25px;
		display: none;
		line-height: 1;
	}

	input:checked ~ &::after {
		display: block;
	}
`

export const CheckboxText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 11px;
	line-height: 103%;
	letter-spacing: -0.01em;
	color: #6b6b6b;
`

export const ConfirmModalActions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-width: 220px;
`

export const ConfirmWrapper = styled.div`
	background: #fff;
	padding: 30px;

	display: flex;
	flex-direction: column;

	align-items: center;
	box-sizing: border-box;

    @media (max-width: 768px) {
		padding: 15px;
	}

	@media (max-width: 480px) {
		width: calc(100vw - 40px);
	}
`

export const ConfirmTitle = styled.h2`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 122%;
	letter-spacing: 0.01em;
	text-align: center;
	color: #01924f;
`

export const CheckboxLabel = styled.label`
	display: flex;
	align-items: center;
	gap: 10px;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 11px;
	line-height: 103%;
	letter-spacing: -0.01em;
	color: #6b6b6b;
	margin: 15px 0;
	cursor: pointer;
`
